// extracted by mini-css-extract-plugin
export default {"buy":"buy_buy__CqPQx","title":"buy_title__pGxRT","icon":"buy_icon__be-Gy","contenido":"buy_contenido__ltaJj"};